/*
  Add to Cart on product cards without leaving the page (asked for on 2026-10-19).

  The card forms (snippets/atlas-card-buy, snippets/atlas-home-card) stay plain POSTs to
  /cart/add, so they still work with scripting off. With it on, this sends the same form to
  the cart by fetch, as Dawn's product form does, and opens the cart drawer with the new
  contents. If the store answers with an error (sold out, a quantity limit), the card says
  so under the button; if the request itself fails, the form is posted the ordinary way.
*/
(() => {
  const FORMS = '.atlas-cardbuy__form, .atlas-hcard__form';

  function say(form, text) {
    let note = form.querySelector('.atlas-cardbuy__error');
    if (!note) {
      note = document.createElement('p');
      note.className = 'atlas-cardbuy__error';
      note.setAttribute('role', 'alert');
      form.appendChild(note);
    }
    note.textContent = text;
  }

  /*
    The click is taken, not the submit: a submit event is what the Stape/GTM form listener
    counts as add_to_cart, and the cart request is counted again, so taking the submit sent
    two add_to_cart events per click. The product page's own button sends one; so does this.
    The submit listener stays for a form submitted some other way.
  */
  function add(event, form) {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return;

    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    if (button.getAttribute('aria-disabled') === 'true') return;
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');
    const old = form.querySelector('.atlas-cardbuy__error');
    if (old) old.remove();

    const body = new FormData(form);
    body.append('sections', drawer.getSectionsToRender().map((s) => s.id));
    body.append('sections_url', window.location.pathname);

    fetch((window.routes && window.routes.cart_add_url) || form.action, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body,
    })
      .then((r) => r.json())
      .catch(() => null)
      .then((state) => {
        if (!state) {
          form.submit();
          return;
        }
        if (state.status) {
          say(form, state.description || state.message || 'This could not be added to the cart.');
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, { source: 'atlas-card', productVariantId: body.get('id'), errors: state.description, message: state.message });
          }
          return;
        }
        drawer.classList.remove('is-empty');
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'atlas-card', productVariantId: body.get('id'), cartData: state });
        }
        drawer.setActiveElement(button);
        drawer.renderContents(state);
      })
      .finally(() => {
        button.removeAttribute('aria-disabled');
        button.classList.remove('loading');
      });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[type="submit"]');
    const form = button && button.closest(FORMS);
    if (form) add(event, form);
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest(FORMS);
    if (form) add(event, form);
  });
})();
